module.exports = __webpack_public_path__ + "HAFEI-logo.png";